export const AUDIENCE = "audience";
export const LICENSE_CATEGORY = "licenseCategory";
export const DOCUMENT = "onlineHelpDocumentFile";

export const audienceOptions = [
  { label: "Owner", value: "OWNER" },
  { label: "BM", value: "BOARD_MEMBER" },
]
